import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const excluirCotaService = async (cotaId: number) => {
  const token = validateToken();

  if (!token) {
    throw new Error("Token invalido");
  }

  const url = `${Globais.DOMINIOBACK}/cota/${cotaId}`;

  try {
    const response = await axios.delete(url, {
      headers: { Authorization: token.AuthStr },
    });

    return response.data;
  } catch (error: any) {
    if (error.response?.data) {
      throw error.response.data;
    }

    throw new Error("Erro ao excluir cota");
  }
};
